// post-t7-2a (bloque F, diseno 3.4 f): LA GEMELA DE IDIOMA DE LAS CUATRO PAGINAS PUBLICAS DE LA SPA.
//
// La portada y la pagina publica de precios viven en dos direcciones cada una: `/` y `/es`,
// `/pricing` y `/es/precios` (las dos en espanol las monta `components/RutasEnEspanol.js` y las
// pre-pinta `scripts/prerender.js` como `es.html` y `es/precios.html`). El EN | ES de esas
// paginas NAVEGA a la gemela del idioma elegido ademas de cambiar el idioma; esta funcion dice
// cual es. Fuera de esas cuatro direcciones devuelve `null`: no se navega a ningun lado.
//
// PURA A PROPOSITO: no importa `lib/language` (que arrastra `api` e `i18n`), asi la puede usar
// cualquier pagina y probarse sola.
const PARES = [
  { en: '/', es: '/es' },
  { en: '/pricing', es: '/es/precios' },
];

/** La ruta sin diagonal final ni `.html` (`/es/` y `/es.html` son `/es`). */
function rutaLimpia(ruta) {
  let r = String(ruta || '').split('?')[0].split('#')[0];
  if (!r) return '';
  if (r.endsWith('.html')) r = r.slice(0, -'.html'.length);
  if (r === '/index') return '/';
  if (r.length > 1 && r.endsWith('/')) r = r.slice(0, -1);
  return r;
}

/**
 * La direccion gemela de `ruta` en el idioma `lang` (`en`, `es`, `es-MX`...), o `null` si `ruta`
 * no es una de las cuatro.
 */
export function gemelaDeIdioma(ruta, lang) {
  const limpia = rutaLimpia(ruta);
  const par = PARES.find((p) => p.en === limpia || p.es === limpia);
  if (!par) return null;
  return String(lang || '').toLowerCase().startsWith('es') ? par.es : par.en;
}

/** True si `ruta` es una de las dos direcciones web en espanol (`/es`, `/es/precios`). */
export function esRutaEnEspanol(ruta) {
  const limpia = rutaLimpia(ruta);
  return PARES.some((p) => p.es === limpia);
}

export { rutaLimpia };
